import { talentPlaylistsInitialState, TalentPlaylistsState } from './store/State'

import talentPlaylistsReducer from './store/Reducer'

import { reset, TalentPlaylistsAction } from './store/Actions'

import ServiceProviderBase from 'lib/ServiceProviderBase'
import IUserPlaylists from 'types/sign-in/IUserPlaylists'

import { IPlaylist } from './Interfaces'

import { sortBy, uniqBy } from 'lodash'

export class TalentPlaylistsService extends ServiceProviderBase<TalentPlaylistsState, TalentPlaylistsAction> {
  constructor() {
    super(talentPlaylistsInitialState)
  }

  reduce(state: TalentPlaylistsState, action: TalentPlaylistsAction): TalentPlaylistsState {
    return talentPlaylistsReducer(state, action)
  }

  reset() {
    this.dispatch(reset())
  }

  parseUserPlaylists(playlists: IUserPlaylists[]): IPlaylist[] {
    return sortBy(
      uniqBy(
        playlists.map(item => ({
          enterprise: item.enterprise_name,
          enterpriseId: item.enterprise_id,
          playlistName: item.playlistName,
          playlistCode: item.playlistCode,
          url: `/enterprise/${encodeURI(item.enterprise_id)}/playlist/${encodeURI(item.playlistCode)}`
        })),
        'playlistCode'
      ),
      (playlist: any) => playlist?.playlistName?.toUpperCase()
    )
  }
}

let instance: TalentPlaylistsService = null

export default (() => {
  if (!instance) {
    instance = new TalentPlaylistsService()
  }
  return instance
})()
